import "./App.css";
import { AnimatePresence } from "framer-motion";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Home from "./Screens/Home/Home.jsx";
import AboutUs from "./Screens/AboutUs/AboutUs.jsx";
import Contact from "./Screens/Contact/Contact.jsx";
import FAQ from "./Screens/FAQ/Faq.jsx";
import Gallery from "./Screens/Gallery/Gallery.jsx";
import Services from "./Screens/Services/Services.jsx"
import EbookBuys from "./Screens/Books/Books.jsx";
import BoardingForm from "./Screens/BoardingForm/BoardingForm.jsx";
import CustomerForm from "./Screens/CustomerForm/CustomerForm.jsx"
import ScrollToTop from "./Animations/ScrollToTop.jsx";

function AnimatedRoutes() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/book" element={<EbookBuys />} />
        <Route path="/boardingform" element={<BoardingForm />} />
        <Route path="/customerform" element={<CustomerForm />} />
      </Routes>
    </AnimatePresence>
  );
}

export default function App() {
  return (
      <Router>
        <ScrollToTop />
        <AnimatedRoutes />
      </Router>
  );
}
